export default event => event.key || event.keyCode;


// WEBPACK FOOTER //
// /node_modules/@mands/mns-fe-pattern-library/lib/mns-fe-utilities/getKeyCode/index.js